import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router} from '@angular/router';
import {Observable, Observer, Subscription} from 'rxjs';

import {UsersService} from '../services/users.service';
import {AuthEventsEmitter} from '../events/auth.events';

@Injectable()
export class WizardReadyGuard implements CanActivate {
    userProfileSubscription: Subscription;

    constructor(
        private readonly usersService: UsersService,
        private readonly router: Router,
        private readonly authEventsEmitter: AuthEventsEmitter
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.usersService.userProfile) {
            if (this.usersService.userProfile.is_wizard_complete || this.usersService.userProfile.is_master_profile === true) {
                return this.router.navigate(['dashboard']);
            }

            return true;
        } else {
            return new Observable((observer: Observer<boolean>) => {
                this.userProfileSubscription = this.authEventsEmitter.userProfileChanged$
                    .subscribe(() => {
                        if (this.usersService.userProfile.is_wizard_complete || this.usersService.userProfile.is_master_profile === true) {
                            this.router.navigate(['dashboard']);

                            observer.next(false);
                            observer.complete();

                            return this.userProfileSubscription.unsubscribe();
                        }

                        observer.next(true);
                        observer.complete();

                        this.userProfileSubscription.unsubscribe();
                    });
            });
        }
    }
}
